import { Link } from 'react-router-dom'
import { SETUP_COPY, SETUP_HREF } from '../../lib/assignmentSetup.js'

/**
 * WHY THIS SURFACE IS READ-ONLY, from `readinessOf()`.
 *
 * 'setup' says "Assignment setup required" and, for an exec, offers the one
 * control that fixes it (Governing Bodies, where Manage Assignments writes the
 * roster). A rep is told who can fix it. The server still decides every write;
 * the link is a door, not a grant.
 *
 * 'unavailable' keeps the caller's own "history unavailable" sentence, because
 * that one is about a real history read failure. If the roster is ALSO missing,
 * both are said: one problem never hides the other.
 *
 * `classes` are the caller's own CSS module classes, so the notice matches the
 * screen it sits on (bowlActions.module.css or BowlCommittees.module.css).
 */
export default function ReadinessNotice({ readiness, isExec = false, unavailableText, pendingText, classes = {}, compact = false, setupHref = SETUP_HREF }) {
  const state = readiness?.state
  if (!state || state === 'ready') return null
  const setupLine = (
    <div className={classes.setup || classes.bad} role="status" data-readiness="setup">
      <p className={classes.setupText || ''}>
        <b>{SETUP_COPY.title}</b>{compact ? null : <> {isExec ? SETUP_COPY.exec : SETUP_COPY.rep}</>}
      </p>
      {isExec && (
        <Link className={classes.btn} to={setupHref} data-fix="assignment-setup">{SETUP_COPY.cta}</Link>
      )}
    </div>
  )
  if (state === 'setup') return setupLine
  const pendingLine = <p className={classes.bad} data-readiness="pending">{pendingText || 'An operation is pending or needs reconciliation. Inspect saved history before another change. Do not repeat it.'}</p>
  if (state === 'pending') return <>{pendingLine}{readiness.rosterMissing ? setupLine : null}</>
  return (
    <>
      <p className={classes.bad} data-readiness="unavailable">{unavailableText}</p>
      {readiness.pending ? pendingLine : null}
      {readiness.rosterMissing ? setupLine : null}
    </>
  )
}
